import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from '@yourcause/common/i18n';
import { SystemTagsService } from '../system-tags.service';
import { SystemTags } from '../typings/system-tags.typing';

@Component({
    selector: 'gc-tag-color-picker',
    templateUrl: './tag-color-picker.component.html',
    styleUrls: ['./tag-color-picker.component.scss'],
    standalone: false
})
export class TagColorPickerComponent {
  @Input() color: SystemTags.TagColor;
  @Input() noLabel: boolean;
  @Output() colorChange = new EventEmitter<SystemTags.TagColor>();

  tagColorClassMap = this.systemTagsService.tagColorClassMap;

  colors = [{
    display: this.i18n.translate('common:textRed', {}, 'Red'),
    value: SystemTags.TagColor.Red
  }, {
    display: this.i18n.translate('common:textGreen', {}, 'Green'),
    value: SystemTags.TagColor.Green
  }, {
    display: this.i18n.translate('common:textBlue', {}, 'Blue'),
    value: SystemTags.TagColor.Blue
  }, {
    display: this.i18n.translate('common:textYellow', {}, 'Yellow'),
    value: SystemTags.TagColor.Yellow
  }];

  constructor (
    private i18n: I18nService,
    private systemTagsService: SystemTagsService
  ) { }
}
